import { ReactElement } from 'react';
import { variables } from '../styles';
import { ValueLabel } from '..';
import { kebabCase, map } from 'lodash/fp';
import { Tab, Tabs, styled } from '@mui/material';

export const TabsNav = ({
  labels,
  currentTab,
  onChange,
  ariaLabel,
}: {
  labels: ValueLabel<number>[];
  currentTab: number;
  onChange: (a: number) => void;
  ariaLabel: string;
}) => {
  return (
    <Tabs
      value={currentTab}
      onChange={(e, newValue) => onChange(newValue)}
      indicatorColor="primary"
      textColor="primary"
      variant="standard"
      aria-label={ariaLabel}>
      {map<{ label: string; value: number }, ReactElement>(
        ({ label, value }) => (
          <Ta
            key={label}
            label={label}
            id={kebabCase(label)}
            tabIndex={value === currentTab ? 0 : -1}
            aria-label={label}
          />
        )
      )(labels)}
    </Tabs>
  );
};

export const Ta = styled(Tab)(({ theme }) => ({
  fontSize: variables.bodyFontSize,
  alignItems: 'baseline',
}));
